import type { ReactNode } from "react";
import { PROFILE_TIER_LEVELS, type ProfileTier, type ProfileTierLevel } from "@usales/contract/profile-tiers";
import "./profile-tiers.css";

const tierNames: Record<ProfileTierLevel, string> = { high: "第一梯队", medium: "第二梯队", low: "第三梯队" };
const tierRanks: Record<ProfileTierLevel, string> = { high: "高匹配", medium: "中匹配", low: "低匹配" };

export function ProfileTierBadge({ level }: { level: ProfileTierLevel }): React.JSX.Element {
  return <span className={`profile-tier-badge profile-tier-badge-${level}`}><span className="profile-tier-number" aria-hidden="true">{PROFILE_TIER_LEVELS.indexOf(level) + 1}</span><b>{tierNames[level]}</b><span className="profile-tier-rank">{tierRanks[level]}</span></span>;
}

export function ProfileTierLegend(): React.JSX.Element {
  return <div className="profile-tier-legend" aria-label="梯队标识说明"><b>维度内的取值梯队</b><div>{PROFILE_TIER_LEVELS.map(level => <ProfileTierBadge key={level} level={level} />)}</div><p>每个维度分别划分取值优先级，与客户整体的 A / B / C 分级分开显示。</p></div>;
}

export interface ProfileTierMatch { state: string; level?: ProfileTierLevel | null }
export function ProfileTierMatchBadge({ tiered, match }: { tiered: boolean; match: ProfileTierMatch }): React.JSX.Element {
  if (!tiered) return <span className="profile-tier-state">旧版条件 · {match.state === "matched" ? "已命中" : match.state === "unmatched" ? "未命中" : "待核验"} · 未划分梯队</span>;
  if (match.state === "matched" && match.level) return <span className="profile-tier-match-label"><b>已命中</b><ProfileTierBadge level={match.level} /></span>;
  return <span className="profile-tier-state">{match.state === "unmatched" ? "未命中已配置梯队" : match.state === "expired" ? "证据已过期 · 待核验" : "资料或证据不足 · 待核验"}</span>;
}

export function ProfileTierConfiguration({ tiers, match, renderCondition }: { tiers?: readonly ProfileTier[]; match?: ProfileTierMatch; renderCondition?: (tier: ProfileTier) => ReactNode }): React.JSX.Element {
  return <div className="profile-tier-configuration" aria-label="各梯队对应取值">{PROFILE_TIER_LEVELS.map(level => {
    const tier = tiers?.find(item => item.level === level);
    const hit = Boolean(tier && match?.state === "matched" && match.level === level);
    return <div className={`profile-tier-value-row${tier ? "" : " is-unset"}${hit ? " is-matched" : ""}`} key={level}>
      <ProfileTierBadge level={level} />
      <div className="profile-tier-value"><div>{tier ? <b>{tier.label || "待填写取值"}</b> : <span>{tiers ? "未配置此档" : "尚未划分"}</span>}{hit && <span className="profile-tier-hit">✓ 已命中</span>}</div>{tier && renderCondition && <p>{renderCondition(tier)}</p>}</div>
    </div>;
  })}</div>;
}
